
import { createApp } from 'vue';
import VueKonva from 'vue-konva';
import App from './components/App.vue';
import axios from "axios";
import { useTranslation } from './composables/useTranslation.js';
import { loadVisualizerFonts } from './utils/visualizerFonts';

loadVisualizerFonts();

const app = createApp(App);

axios.defaults.baseURL = "http://localhost:8099";

// Rejestracja axios jako globalnej właściwości
app.config.globalProperties.$axios = axios;

// Rejestracja systemu tłumaczeń jako globalnej właściwości
const { $t, setLanguage, currentLanguage } = useTranslation();
app.config.globalProperties.$t = $t;
app.config.globalProperties.$setLanguage = setLanguage;
app.config.globalProperties.$currentLanguage = currentLanguage;

// Rejestruj Vue Konva
app.use(VueKonva);

app.mount('#app');